/* eslint-disable quote-props */
import React from "react";
import useTypography, { UseTypographyOptions, Accents, Colors, FontSizes, Tags, Variants } from "./hooks/useTypography";

interface Props extends UseTypographyOptions, Omit<React.AllHTMLAttributes<HTMLOrSVGElement>, "color" | "as"> {
    children: React.ReactNode;
}

const Typography = ({ as: Tag = "span", variant, color, children, className = "", fontSize, accent, ...props }: Props) => {
    const cn = useTypography({
        variant,
        color,
        className,
        fontSize,
        accent,
    });

    return (
        <Tag {...props} className={cn}>
            {children}
        </Tag>
    );
};

Typography.colors = Colors;
Typography.tags = Tags;
Typography.variants = Variants;
Typography.Accents = Accents;
Typography.FontSizes = FontSizes;

export default Typography;
